import styles from '../Dialogs/CustomerDoc/styles';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import {useContext, useEffect, useMemo} from 'react';
import { AppContext } from '../../context';
import { IAccount } from '../../resource';

type Props = {
  multiple?: boolean;
  includeMe?: boolean;
  value?: any | null;
  onChange: (value: any | null) => void;
  loading?: boolean;
};

export const UserSelector = ({ multiple, value, includeMe, onChange, loading = false }: Props) => {
  const { isAdmin, users, account } = useContext(AppContext);

  useEffect(() => {
    if (isAdmin) {
      users.fetchData();
    }
  }, [isAdmin]);

  const handleOnChange = (value: IAccount | IAccount[] | null) => {
    onChange(value);
  };

  const selectedValue = useMemo(() => {
    if (multiple) {
      if (!value || !Array.isArray(value)) return [];
      // Filter users based on the selected values
      return users.value?.filter((user) => 
        value.some((valueItem) => 
          (typeof valueItem === 'string' && valueItem === user.id) || 
          (typeof valueItem === 'object' && valueItem.id === user.id)
        )
      ) || [];
    }
    return value;
  }, [value, users.value, multiple]);

  return (
    <Autocomplete
      id="combo-box-demo"
      disablePortal
      limitTags={1}
      multiple={multiple}
      getOptionLabel={(option: IAccount) => option.id === account?.id ? 'Me' : `${option.firstName} ${option.lastName}`}
      options={users.value?.filter((user) => includeMe || user.id !== account?.id) || []}
      value={selectedValue}
      sx={styles.userSelect}
      onChange={(_, value) => {
        handleOnChange(value as any);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          sx={{ minWidth: '300px' }}
          label={multiple ? "Select Users" : "Select User"}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? (
                  <CircularProgress color="secondary" size={20} sx={{ position: 'absolute', right: 0 }} />
                ) : (
                  params.InputProps.endAdornment
                )}
              </>
            ),
          }}
        />
      )}
    />
  )
};
